import React, { useEffect, useState } from 'react';
import Select from 'react-select';
// import DatePicker from 'react-datepicker';
import DatePicker from 'react-date-picker';
// import 'react-datepicker/dist/react-datepicker.css';
import '../../style/editablegrid.css';
import SelectSearch, { fuzzySearch } from "react-select-search";
import "../../style/select-search.css";
import configData from '../../configData.json';
import moment from 'moment';
import { formatInputDate, toLocalDate } from '../Utlities';

export default function AccBusinessPortionLostService({ sccData, onUpdateGridData, selectedCust, onDeleteRows }) {

    const [gridData, setGridData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
    const [fbTypeOptions, setFbTypeOptions] = useState([]);
    const [scTypeOptions, setScTypeOptions] = useState([]);
    const [upsellTypeOptions, setUpsellTypeOptions] = useState([]);
    const [cust, setCust] = useState(0);

    useEffect(() => {
        // debugger;
        setCust(selectedCust);
        if (Array.isArray(sccData)) {
            // debugger;
            const filteredNvisionServices = sccData.filter(
                service => service.serviceType === "SL"
            );
             // Map the filtered services
             const updatedNvisionServices = filteredNvisionServices.map(service => ({
                ...service,
                serviceDateValue: toLocalDate(service.serviceDate)
            }));
            setGridData(updatedNvisionServices);
        } else {
            setGridData([]);
        }
        // debugger;
        LoadServiceTypes();
        LoadNvisionServiceCodes();
        LoadSupplyChainServiceCodes();
        LoadUpsellServiceCodes();

    }, [sccData]);

    useEffect(() => {
        onUpdateGridData(gridData);
    }, [gridData]);

    const LoadServiceTypes = async () => {
        // debugger;
        setLoading(true);
        const serviceUrl = `${configData.BASE_APP_URL}CustomerSetup/GetTypeOfServices`;
        await fetch(serviceUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let serviceTypes = [];
                resp.map(service => {
                    const ser = {
                        "name": service.codeTypeDescription.toUpperCase(),
                        "value": service.codeType
                    }
                    serviceTypes = [...serviceTypes, ser];
                })
                const defaultServiceType = {
                    "name": "--Select A Value--",
                    "value": 0
                }
                serviceTypes.unshift(defaultServiceType);
                setServiceTypeOptions(serviceTypes)

            })
        setLoading(false);
    };

    const LoadNvisionServiceCodes = async () => {
        // debugger;
        setLoading(true);
        const serviceUrl = `${configData.BASE_APP_URL}CustomerSetup/GetNvisionServiceCodes`;
        await fetch(serviceUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let serviceOptions = [];
                resp.map(service => {
                    const ser = {
                        "name": service.codeDesc,
                        "value": service.codeID
                    }
                    serviceOptions = [...serviceOptions, ser];
                })
                const defaultService = {
                    "name": "--Select A Value--",
                    "value": ""
                }
                serviceOptions.unshift(defaultService);
                setFbTypeOptions(serviceOptions)

            })
        setLoading(false);
    };

    const LoadSupplyChainServiceCodes = async () => {
        // debugger;
        setLoading(true);
        const serviceUrl = `${configData.BASE_APP_URL}CustomerSetup/GetSupplyChainServiceCodes`;
        await fetch(serviceUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let serviceOptions = [];
                resp.map(service => {
                    const ser = {
                        "name": service.codeDesc,
                        "value": service.codeID
                    }
                    serviceOptions = [...serviceOptions, ser];
                })
                const defaultService = {
                    "name": "--Select A Value--",
                    "value": ""
                }
                serviceOptions.unshift(defaultService);
                setScTypeOptions(serviceOptions)

            })
        setLoading(false);
    };

    const LoadUpsellServiceCodes = async () => {
        // debugger;
        setLoading(true);
        const serviceUrl = `${configData.BASE_APP_URL}CustomerSetup/GetUpsellServiceCodes`;
        await fetch(serviceUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let serviceOptions = [];
                resp.map(service => {
                    const ser = {
                        "name": service.codeDesc,
                        "value": service.codeID
                    }
                    serviceOptions = [...serviceOptions, ser];
                })
                const defaultService = {
                    "name": "--Select A Value--",
                    "value": ""
                }
                serviceOptions.unshift(defaultService);
                setUpsellTypeOptions(serviceOptions)

            })
        setLoading(false);
    };


    const handleTypeServiceChange = (newValue, row) => {
         debugger;
        console.log('handleTypeServiceChange');
        const updatedData = gridData.map(item => {
            // debugger;
            if (item.id === row.id) {
                const isServiceTypeChanged = item.codeType !== newValue.value;

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isServiceTypeChanged) {
                    dirtyFlag = 'I';
                } else if (isServiceTypeChanged) {
                    dirtyFlag = 'U';
                }

                const updatedRow = {
                    ...item,
                    codeType: newValue,
                    codeId: "", // Reset codeId to 0
                    codeDesc: '--Select A Value--', // Reset codeDesc to "--Select A Value--"
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username')
                };

                return updatedRow;
            }
            return item;
        });

        setGridData(updatedData);
        onUpdateGridData(updatedData);

    };


    const handleServiceChange = (newValue, row) => {
        debugger;
        const username = sessionStorage.getItem('my-username');
        let selectedService = null;
        switch (row.codeType) {
            case "SVCNVISI":
                selectedService = fbTypeOptions.find(option => option.value === newValue);
                break;
            case "SVCSCS":
                selectedService = scTypeOptions.find(option => option.value === newValue);
                break;
            case "UPSELLS":
                selectedService = upsellTypeOptions.find(option => option.value === newValue);
                break;
            default:
                break;
        }

        if (selectedService) {
            setGridData(prevGridData => {
                debugger;
                const updatedData = prevGridData.map(item => {
                    debugger;
                    if (item.id === row.id) {
                        const isServiceChanged = item.codeId !== selectedService.value;

                        let dirtyFlag = item.dirtyFlag;

                        if (row.isNew && isServiceChanged) {
                            dirtyFlag = 'I';
                        } else if (isServiceChanged) {
                            dirtyFlag = 'U';
                        }

                        return {
                            ...item,
                            codeId: selectedService.value,
                            codeDesc: selectedService.name,
                            dirtyFlag: dirtyFlag,
                            modifiedBy: item.isNew ? '' : username
                            // modifiedOn: item.isNew ? '' : new Date().toISOString()
                        };
                    }
                    return item;
                });
                // debugger;
                onUpdateGridData(updatedData);
                return updatedData;
            });
        }
    };


    const getServiceOptionsForCodeType = (row) => {
        // debugger;

        switch (row.codeType) {
            case "SVCNVISI":
                return fbTypeOptions;
            case "SVCSCS":
                return scTypeOptions;
            case "UPSELLS":
                return upsellTypeOptions;
            default:
                return [
                    {
                        name: "--Select A Value--",
                        value: 0
                    }
                ];
        }
    };

    const handleDateOfServiceChange = (newDate, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {

                // Check if newDate is null
                const isDateChanged = newDate !== null && item.serviceDate !== moment(newDate).format().substring(0, 10);

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isDateChanged) {
                    dirtyFlag = 'I';
                } else if (isDateChanged) {
                    dirtyFlag = 'U';
                }
                return {
                    ...item,
                    // serviceDate: newDate !== null ? moment(newDate).format().substring(0, 10) : null,
                    serviceDateValue: newDate,
                    serviceDate: formatInputDate(newDate),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                    // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                };
            }
            return item;
        });

        // Update data immediately and notify parent component
        setGridData(updatedData);
        onUpdateGridData(updatedData);
    };

    const handleTextChange = (newValue, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {
                const isTextChanged = item.comments !== newValue;

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isTextChanged) {
                    dirtyFlag = 'I';
                } else if (isTextChanged) {
                    dirtyFlag = 'U';
                }

                return {
                    ...item,
                    comments: newValue,
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                    // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                };
            }
            return item;
        });

        // Update data immediately and notify parent component
        setGridData(updatedData);
        onUpdateGridData(updatedData);
    };


    const handleCheckboxChange = (checked, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {
                return { ...item, checked };
            }
            return item;
        });
        setGridData(updatedData);
    };

    const generateNewRow = () => {
        const username = sessionStorage.getItem('my-username');
        const timestamp = new Date().getTime().toString(); // Use current timestamp as string

        return {
            id: timestamp, // Unique ID based on timestamp
            checked: false,
            customerKey: cust,
            codeId: "",
            codeDesc: '--Select A Value--',
            serviceDateValue: null,
            serviceDate: null,
            codeType: "",
            serviceType: "SL",
            comments: "",
            createdBy: username,
            // createdOn: new Date().toISOString(),
            dirtyFlag: 'I',
            isNew: true
        };
    };

    const handleAddRow = () => {
        const newRow = generateNewRow();
        setGridData([...gridData, newRow]);
    };

    const handleDeleteRows = async () => {
        // Get the IDs of rows to be deleted
        debugger;
        const selectedRowIds = gridData.filter(row => row.checked && !row.isNew).map(row => row.id);

        if (selectedRowIds.length === 0) {
            // If no rows are selected for deletion, return early
            const updatedData = gridData.filter(row => !row.checked);
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            const deletedRowCount = selectedRowIds.length;
            onDeleteRows(deletedRowCount);
            return;
        }

        // Prepare the request URL with customer_key and comma-separated IDs
        const customerKey = cust; // Use the 'cust' state for customer_key
        const idsToDelete = selectedRowIds.join(',');

        const apiUrl = `${configData.BASE_APP_URL}CustomerSetup/DeleteVolumeByCustomer?customerkey=${customerKey}&ids=${idsToDelete}`;

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            if (response.ok) {
                // Delete was successful, update the state and notify parent component
                window.alert('Data deleted successfully.');
                const updatedData = gridData.filter(row => !row.checked);
                setGridData(updatedData);
                onUpdateGridData(updatedData);
                const deletedRowCount = selectedRowIds.length;
                onDeleteRows(deletedRowCount);
                // window.confirm('Data deleted successfully.');
            } else {
                // Handle error response from the API if needed
                console.error('Error deleting rows:', response.statusText);
                window.alert('Error deleting data.');
            }
        } catch (error) {
            // Handle network or other errors if needed
            console.error('Error deleting rows:', error);
            window.alert('Error deleting data.');
        }
    };


    function formatDateTime(dateTime) {
        if (dateTime) {
            return new Date(dateTime).toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true,
                timeZone: 'UTC'
            });
        }
        return '';
    }

    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id="headingFour">
                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                    Business or Portion Lost Service
                </button>
            </h2>
            <div id="collapseFour" className="accordion-collapse collapse show" aria-labelledby="headingFour" data-bs-parent="#accordionSettings">
                <div className="accordion-body">

                    <div className='custom-table-text accordian-table'>
                        <button className='btn btn-filter mb-2' onClick={handleAddRow}> <i className='fa fa-plus'></i> Add</button>
                        <button className='btn btn-clear ms-2 mb-2' onClick={handleDeleteRows}> <i className='fa fa-trash'></i> Delete</button>
                        <div className='react-bootstrap-table'>
                            <table className='table table-striped table-hover'>
                                <thead>
                                    <tr className='table-top'>
                                        <th className='center-align' width='30px'></th>
                                        <th className='center-align' width='250px'>Type Of Service</th>
                                        <th className='center-align hidden-column' width='100px'>CodeID</th>
                                        <th className='center-align' width='550px'>Business or Portion Lost Service Description</th>
                                        <th className='center-align' width='120px'>Business or Portion Lost Date</th>
                                        <th className='center-align' width='250px'>Business or Portion Lost Notes</th>
                                        <th className='center-align' width='100px'>Created By</th>
                                        <th className='center-align' width='100px'>Created On</th>
                                        <th className='center-align' width='100px'>Modified By</th>
                                        <th className='center-align' width='100px'>Modified On</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {gridData.map((row, index) => (
                                        <tr
                                            key={row.id}
                                        >
                                            <td className='center-align'>
                                                <input
                                                    type='checkbox'
                                                    checked={row.checked}
                                                    onChange={e => handleCheckboxChange(e.target.checked, row)}
                                                />
                                            </td>
                                            <td className='center-align'>
                                                <SelectSearch
                                                    id="ddnTypeService"
                                                    name="ddnTypeService"
                                                    className="select-search"
                                                    value={row.codeType}
                                                    options={serviceTypeOptions}
                                                    onChange={newValue => handleTypeServiceChange(newValue, row)}
                                                    search
                                                    filterOptions={fuzzySearch}

                                                >
                                                </SelectSearch>
                                            </td>
                                            <td className='center-align hidden-column'>{row.codeID}</td>
                                            <td className='center-align'>
                                                <SelectSearch
                                                    id={`ddnService-${row.id}`}
                                                    name={`ddnService-${row.id}`}
                                                    className="select-search"
                                                    value={row.codeId}
                                                    options={getServiceOptionsForCodeType(row)}
                                                    onChange={newValue => handleServiceChange(newValue, row)}
                                                    search
                                                    filterOptions={fuzzySearch}

                                                />
                                            </td>
                                            <td className='center-align'>
                                                <DatePicker
                                                    // value={row.serviceDate !== null ? new Date(row.serviceDate) : null}
                                                    value={row.serviceDateValue}
                                                    onChange={newDate => handleDateOfServiceChange(newDate, row)}
                                                    calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                                    format='MM/dd/yyyy'
                                                    fixedHeight
                                                    openCalendarOnFocus = {false}
                                                />
                                            </td>
                                            <td className='center-align'>
                                                <textarea style={{ width: "100%" }}
                                                    rows="2"
                                                    value={row.comments}
                                                    onChange={e => handleTextChange(e.target.value, row)}
                                                />
                                            </td>
                                            <td className='center-align'>{row.createdBy ? row.createdBy.toUpperCase() : ''}</td>
                                            <td className='center-align'>{formatDateTime(row.createdOn)}</td>
                                            <td className='center-align'>{row.modifiedBy ? row.modifiedBy.toUpperCase() : ''}</td>
                                            <td className='center-align'>{formatDateTime(row.modifiedOn)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

